import React from "react";

function CellWithCurrentNewValue(
    data,
    valueLabels = {
        current: "current",
        new: "new",
    }
) {
    return (
        <div className="table-cell_with-current-new">
            {data.currentValue === data.newValue ? (
                data.currentValue
            ) : (
                <>
                    <div>
                        <span>{valueLabels.current}</span>
                        <span>{data.currentValue}</span>
                    </div>
                    <div>
                        <span>
                            <b>{valueLabels.new}</b>
                        </span>
                        <span>
                            <b>{data.newValue}</b>
                        </span>
                    </div>
                </>
            )}
        </div>
    );
}

export default CellWithCurrentNewValue;

